import { apiClient } from "../api";

/**
 * Servicio de evidencias.
 * API: http://localhost:8080/evidencias
 */

/**
 * Obtiene la lista de evidencias.
 */
export const getEvidencias = async () => {
  const { data } = await apiClient.get("evidencias");
  return data;
};

/**
 * Obtiene una evidencia por ID.
 * @param {number|string} id - ID de la evidencia
 */
export const getEvidencia = async (id) => {
  const { data } = await apiClient.get(`evidencias/${id}`);
  return data;
};

/**
 * Crea una nueva evidencia.
 * @param {Object} payload - { Seccion, Titular, SubTitulo, Cuerpo, Fuente, Imagen, Fecha, Estado }
 */
export const createEvidencia = async (payload) => {
  const { data } = await apiClient.post("evidencias", payload);
  return data;
};

/**
 * Actualiza una evidencia existente.
 * @param {number|string} id - ID de la evidencia
 * @param {Object} payload - Campos a actualizar
 */
export const updateEvidencia = async (id, payload) => {
  const { data } = await apiClient.put(`evidencias/${id}`, payload);
  return data;
};
